import { Badge, Text } from '@mantine/core';

import { useCategoryTitle } from '../api/queries';
import type { Category } from '../api/types';
import { categoryColor, categoryLabel } from '../lib/categories';

/**
 * An operation without a category shows as plain dimmed text rather than as a
 * grey badge: nothing was chosen, and a badge would read as if something had been.
 */
export function CategoryBadge({ category }: { category: Category | null }) {
  const titleOf = useCategoryTitle();

  if (category === null) {
    return (
      <Text size="xs" c="dimmed" fs="italic">
        без категории
      </Text>
    );
  }

  return (
    <Badge color={categoryColor(category)} size="sm">
      {categoryLabel(category, titleOf(category))}
    </Badge>
  );
}
